export default {"src":"/_next/static/media/our-partners-img-three.f2b8e791.svg","height":54,"width":150};